import styled from "styled-components";

import { space } from "shared/styles/constants";

export interface StyledListProps {
  space?: keyof typeof space;
}

export const StyledList = styled.ul<StyledListProps>`
  list-style: outside disc;

  margin-left: ${space.m} !important;

  > li + li {
    margin-top: ${({ space: gapSize }) => space[gapSize || "xs"]};
  }
`;
